const PASSWORD = "QpSfazLD0ZjQZRByFdoP";

export let encrypt = (text) => {
  return btoa(CryptoJS.AES.encrypt(text, PASSWORD));
};

export let decrypt = (text) => {
  return CryptoJS.AES.decrypt(atob(text), PASSWORD).toString(CryptoJS.enc.Utf8);
};
